import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { DocumentService } from '../../services/document.service';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule, RouterModule],
  template: `
    <div class="app-layout">
      <!-- Navbar -->
      <nav class="navbar glass">
        <div class="logo">
          <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>
          Sorrus
        </div>
        <div class="nav-links">
          <a routerLink="/launcher" class="back-link">
            <svg viewBox="0 0 24 24" width="18" height="18" stroke="currentColor" stroke-width="2" fill="none"><polyline points="15 18 9 12 15 6"></polyline></svg>
            Hub
          </a>
          <a routerLink="/pdf-signer" class="active">Dashboard</a>
          <a routerLink="/pdf-signer/contacts">Kontakte</a>
          <a routerLink="/pdf-signer/settings">Einstellungen</a>
        </div>
        <div class="avatar">YS</div>
      </nav>

      <main class="main-content">
        <!-- Hero Section -->
        <div class="hero glass-panel">
          <div class="hero-content">
            <h1>Verträge digital signieren. <br><span class="text-gradient">Schnell & Rechtsgültig.</span></h1>
            <p>Laden Sie ein PDF hoch, bestimmen Sie die Empfänger und holen Sie rechtsverbindliche Unterschriften in Minuten ein.</p>
            
            <!-- Upload Area -->
            <div class="upload-zone" [class.uploading]="isUploading">
              <input type="file" #fileInput (change)="onFileSelected($event)" accept="application/pdf" style="display: none">
              
              <div class="upload-content" *ngIf="!isUploading" (click)="fileInput.click()">
                <div class="icon-circle">
                  <svg viewBox="0 0 24 24" width="32" height="32" stroke="currentColor" stroke-width="2" fill="none"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="17 8 12 3 7 8"></polyline><line x1="12" y1="3" x2="12" y2="15"></line></svg>
                </div>
                <h3>Dokument hochladen</h3>
                <p>Klicken oder PDF hierher ziehen (max. 10MB)</p>
              </div>

              <div class="upload-actions" *ngIf="!isUploading">
                 <button class="btn-template-upload" (click)="$event.stopPropagation(); fileInput.click(); isTemplateUpload = true">
                   <svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2" fill="none"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline></svg>
                   Als Vorlage hochladen
                 </button>
              </div>

              <div class="loading-state" *ngIf="isUploading">
                <div class="spinner"></div>
                <p>Dokument wird verschlüsselt und hochgeladen...</p>
              </div>
            </div>
          </div>
          <div class="hero-decoration">
            <div class="glow-orb orb-1"></div>
            <div class="glow-orb orb-2"></div>
          </div>
        </div>

        <!-- Dashboard / Dokumenten-Liste -->
        <div class="dashboard-section" *ngIf="templates.length > 0">
          <h2>Vorlagen</h2>
          <div class="documents-grid">
            <div class="doc-card glass-panel template-card" *ngFor="let doc of templates" (click)="goToEditor(doc.id)">
              <div class="doc-header-row">
                <div class="doc-icon" style="background: rgba(168, 85, 247, 0.1); color: #a855f7;">
                  <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline></svg>
                </div>
                <button class="btn-delete" (click)="deleteDocument($event, doc.id)" title="Löschen">
                  <svg viewBox="0 0 24 24" width="18" height="18" stroke="currentColor" stroke-width="2" fill="none"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>
                </button>
              </div>
              <div class="doc-info">
                <h4>{{ doc.originalName }}</h4>
                <span class="status-badge" style="background: rgba(168, 85, 247, 0.1); color: #a855f7;">Vorlage</span>
              </div>
              <div class="doc-meta">
                <span>{{ doc.textFields?.length || 0 }} Textfelder</span>
                <span>{{ doc.signers?.length || 0 }} Unterzeichner</span>
              </div>
            </div>
          </div>
        </div>

        <div class="dashboard-section">
          <h2>Aktuelle Anfragen</h2>
          <div class="documents-grid" *ngIf="activeDocuments.length > 0; else noDocs">
            
            <div class="doc-card glass-panel" *ngFor="let doc of activeDocuments" (click)="goToEditor(doc.id)">
              <div class="doc-header-row">
                <div class="doc-icon">
                  <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path></svg>
                </div>
                <button class="btn-delete" (click)="deleteDocument($event, doc.id)" title="Löschen">
                  <svg viewBox="0 0 24 24" width="18" height="18" stroke="currentColor" stroke-width="2" fill="none"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>
                </button>
              </div>
              <div class="doc-info">
                <h4>{{ doc.originalName }}</h4>
                <span class="status-badge" [ngClass]="doc.status">
                  {{ doc.status === 'completed' ? 'Abgeschlossen' : doc.status === 'sent' ? 'Wartet auf Unterschriften' : 'Entwurf' }}
                </span>
              </div>
              
              <div class="doc-progress" *ngIf="doc.signers?.length > 0">
                <div class="progress-text">
                  <span>{{ getSignedCount(doc.signers) }} / {{ doc.signers.length }} unterschrieben</span>
                </div>
                <div class="progress-bar-bg">
                  <div class="progress-bar-fill" [style.width]="(getSignedCount(doc.signers) / doc.signers.length * 100) + '%'"></div>
                </div>
              </div>
            </div>

          </div>
          <ng-template #noDocs>
            <div class="empty-state glass-panel">
              <svg viewBox="0 0 24 24" width="48" height="48" stroke="#475569" stroke-width="1" fill="none"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="9" y1="3" x2="9" y2="21"></line></svg>
              <p>Noch keine Dokumente hochgeladen.</p>
            </div>
          </ng-template>
        </div>
      </main>
    </div>
  `,
  styles: [`
    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');

    :host {
      font-family: 'Inter', sans-serif;
      display: block;
      min-height: 100vh;
      background-color: #0f172a;
      color: #f8fafc;
    }

    .app-layout { display: flex; flex-direction: column; min-height: 100vh; }
    
    .glass {
      background: rgba(15, 23, 42, 0.7);
      backdrop-filter: blur(12px);
      border-bottom: 1px solid rgba(255,255,255,0.05);
    }

    .glass-panel {
      background: rgba(30, 41, 59, 0.5);
      backdrop-filter: blur(16px);
      border: 1px solid rgba(255,255,255,0.05);
      border-radius: 1.5rem;
    }

    .navbar {
      display: flex; justify-content: space-between; align-items: center;
      padding: 1rem 3rem; position: sticky; top: 0; z-index: 100;
    }

    .logo {
      font-size: 1.25rem; font-weight: 700; display: flex; align-items: center; gap: 0.5rem;
      color: #f8fafc;
    }
    .logo svg { color: #38bdf8; }

    .nav-links { display: flex; gap: 2rem; }
    .nav-links a { color: #94a3b8; text-decoration: none; font-weight: 500; transition: color 0.2s; display: flex; align-items: center; gap: 0.25rem; }
    .nav-links a:hover, .nav-links a.active { color: #38bdf8; }
    .back-link { border-right: 1px solid rgba(255,255,255,0.1); padding-right: 1.5rem; margin-right: 0.5rem; }

    .avatar {
      width: 40px; height: 40px; border-radius: 50%;
      background: linear-gradient(135deg, #38bdf8, #818cf8);
      display: flex; align-items: center; justify-content: center;
      font-weight: 700; color: white;
    }

    .main-content {
      flex: 1; padding: 3rem; max-width: 1200px; margin: 0 auto; width: 100%; box-sizing: border-box;
      display: flex; flex-direction: column; gap: 3rem;
    }

    .hero {
      position: relative; padding: 4rem; overflow: hidden;
      display: flex; align-items: center; justify-content: center;
    }

    .hero-content {
      position: relative; z-index: 10; max-width: 600px; text-align: center;
    }

    .hero h1 { font-size: 3rem; font-weight: 800; line-height: 1.2; margin: 0 0 1rem; }
    .text-gradient {
      background: linear-gradient(to right, #38bdf8, #818cf8);
      -webkit-background-clip: text; -webkit-text-fill-color: transparent;
    }
    .hero p { color: #94a3b8; font-size: 1.1rem; line-height: 1.6; margin-bottom: 2.5rem; }

    .upload-zone {
      border: 2px dashed rgba(56, 189, 248, 0.3); border-radius: 1rem;
      background: rgba(15, 23, 42, 0.4); transition: all 0.3s ease;
      cursor: pointer; position: relative; overflow: hidden;
    }
    .upload-zone:hover {
      border-color: #38bdf8; background: rgba(56, 189, 248, 0.05); transform: translateY(-2px);
    }
    .upload-content { padding: 3rem 2rem; display: flex; flex-direction: column; align-items: center; gap: 1rem; }
    .icon-circle {
      width: 64px; height: 64px; border-radius: 50%; background: rgba(56, 189, 248, 0.1);
      color: #38bdf8; display: flex; align-items: center; justify-content: center;
    }
    .upload-content h3 { margin: 0; color: #f8fafc; font-size: 1.2rem; }
    .upload-content p { margin: 0; color: #64748b; font-size: 0.9rem; }

    .loading-state {
      padding: 4rem 2rem; display: flex; flex-direction: column; align-items: center; gap: 1rem; color: #38bdf8;
    }
    .spinner {
      width: 40px; height: 40px; border: 4px solid rgba(56, 189, 248, 0.2);
      border-top-color: #38bdf8; border-radius: 50%; animation: spin 1s linear infinite;
    }
    @keyframes spin { 100% { transform: rotate(360deg); } }

    .hero-decoration { position: absolute; top: 0; left: 0; right: 0; bottom: 0; z-index: 1; pointer-events: none; overflow: hidden; }
    .glow-orb { position: absolute; border-radius: 50%; filter: blur(80px); opacity: 0.5; }
    .orb-1 { top: -100px; left: -100px; width: 300px; height: 300px; background: #0ea5e9; }
    .orb-2 { bottom: -100px; right: -100px; width: 400px; height: 400px; background: #4f46e5; }

    .dashboard-section h2 { font-size: 1.5rem; margin-bottom: 1.5rem; }

    .documents-grid {
      display: grid; grid-template-columns: repeat(auto-fill, minmax(300px, 1fr)); gap: 1.5rem;
    }

    .doc-card {
      padding: 1.5rem; cursor: pointer; transition: transform 0.2s, box-shadow 0.2s;
      display: flex; flex-direction: column; gap: 1rem; position: relative;
    }
    .doc-card:hover { transform: translateY(-4px); box-shadow: 0 10px 25px rgba(0,0,0,0.2); border-color: rgba(56, 189, 248, 0.3); }

    .doc-header-row { display: flex; justify-content: space-between; align-items: flex-start; }

    .doc-icon {
      width: 48px; height: 48px; border-radius: 12px; background: rgba(56, 189, 248, 0.1);
      color: #38bdf8; display: flex; align-items: center; justify-content: center;
    }

    .btn-delete {
      background: transparent; border: none; color: #64748b; cursor: pointer; padding: 0.5rem;
      border-radius: 0.5rem; transition: all 0.2s ease;
    }
    .btn-delete:hover { background: rgba(248, 113, 113, 0.1); color: #f87171; }

    .doc-info h4 { margin: 0 0 0.5rem; font-size: 1.1rem; color: #f1f5f9; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
    
    .status-badge {
      display: inline-block; padding: 0.25rem 0.75rem; border-radius: 999px; font-size: 0.75rem; font-weight: 600; text-transform: uppercase;
    }
    .status-badge.completed { background: rgba(52, 211, 153, 0.1); color: #34d399; }
    .status-badge.sent { background: rgba(251, 191, 36, 0.1); color: #fbbf24; }
    .status-badge.draft { background: rgba(148, 163, 184, 0.1); color: #94a3b8; }

    .doc-progress { margin-top: auto; padding-top: 1rem; border-top: 1px solid rgba(255,255,255,0.05); }
    .progress-text { display: flex; justify-content: space-between; font-size: 0.8rem; color: #cbd5e1; margin-bottom: 0.5rem; }
    .progress-bar-bg { height: 6px; background: rgba(255,255,255,0.1); border-radius: 3px; overflow: hidden; }
    .progress-bar-fill { height: 100%; background: #38bdf8; transition: width 0.3s ease; }

    .empty-state {
      padding: 4rem; text-align: center; color: #64748b; display: flex; flex-direction: column; align-items: center; gap: 1rem;
    }

    .btn-template-upload {
      margin-bottom: 1.5rem;
      background: rgba(168, 85, 247, 0.1);
      border: 1px solid rgba(168, 85, 247, 0.2);
      color: #a855f7;
      padding: 0.5rem 1rem;
      border-radius: 0.5rem;
      font-size: 0.85rem;
      font-weight: 600;
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 0.5rem;
      transition: all 0.2s;
    }
    .btn-template-upload:hover { background: #a855f7; color: white; }

    .doc-meta { font-size: 0.75rem; color: #64748b; display: flex; justify-content: space-between; }
    .template-card:hover { border-color: rgba(168, 85, 247, 0.4); }
  `]
})
export class HomeComponent implements OnInit {
  isUploading = false;
  documents: any[] = [];
  
  private router = inject(Router);
  private documentService = inject(DocumentService);

  ngOnInit() {
    this.loadDocuments();
  }

  loadDocuments() {
    this.documentService.getAllDocuments().subscribe({
      next: (docs) => {
        this.documents = docs;
        this.templates = docs.filter(d => d.isTemplate);
        this.activeDocuments = docs.filter(d => !d.isTemplate);
      },
      error: (err) => console.error('Failed to load documents', err)
    });
  }

  isTemplateUpload = false;
  templates: any[] = [];
  activeDocuments: any[] = [];

  getSignedCount(signers: any[]): number {
    if (!signers) return 0;
    return signers.filter(s => s.status === 'signed').length;
  }

  goToEditor(docId: string) {
    this.router.navigate(['/pdf-signer/editor', docId]);
  }

  deleteDocument(event: Event, docId: string) {
    event.stopPropagation();
    if (confirm('Möchten Sie diese Signaturanfrage wirklich löschen?')) {
      this.documentService.deleteDocument(docId).subscribe({
        next: () => {
          this.loadDocuments();
        },
        error: (err) => alert('Fehler beim Löschen des Dokuments.')
      });
    }
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (file && file.type === 'application/pdf') {
      this.isUploading = true;
      this.documentService.upload(file, this.isTemplateUpload).subscribe({
        next: (response) => {
          this.isUploading = false;
          this.isTemplateUpload = false;
          this.router.navigate(['/pdf-signer/editor', response.id]);
        },
        error: (err) => {
          this.isUploading = false;
          alert('Upload fehlgeschlagen');
        }
      });
    } else {
      alert('Bitte laden Sie eine gültige PDF-Datei hoch.');
    }
  }
}
